<div class="content-area">
  <app-loading-component *ngIf="isLoading"></app-loading-component>
  <div class="clr-row" *ngIf="!isLoading && post">
    <div class="clr-col-12 clr-col-md-8 post-wrapper">
      <div *ngIf="!hideFeaturedImage" class="featured-image-wrapper" [style.backgroundImage]="postImage"></div>
      <h1 class="text-center" [innerHTML]="post.title.rendered"></h1>
      <div class="text-center">
        <span class="tag mr-1 py-1 px-2" *ngFor="let category of categories">{{category}}</span>
      </div>
      <div [innerHTML]="sanitizedContent" class="post-content mt-4"></div>

      <div>
        <disqus [identifier]="post.title.rendered"></disqus>
      </div>
    </div>
  </div>
</div>
